import * as React from "react";
import styled  from "styled-components";

import {
    Grid,
    Hidden,
    Menu,
    MenuItem,
    AppBar as MuiAppBar,
    IconButton as MuiIconButton,
    Toolbar, Typography
} from "@material-ui/core";

import { Menu as MenuIcon } from "@material-ui/icons";

import {
    Power
} from "react-feather";
import { PAGE_HEADER_ACTIONS_SLOT_ID, PAGE_TITLE_SLOT_ID } from "../../shared/ui/HeaderSlot";
import { useSession } from "../../shared/hooks/useSession";


const AppBar = styled(MuiAppBar)`
  background: ${props => props.theme.header.background};
  color: ${props => props.theme.header.color};
  box-shadow: ${props => props.theme.shadows[1]};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

/*const Indicator = styled(Badge)`
  .MuiBadge-badge {
    background: ${props => props.theme.header.indicator.background};
    color: ${props => props.theme.palette.common.white};
  }
`;*/


function UserMenu(props: {
    logout: () => void
}) {
    const [anchorMenu, setAnchorMenu] = React.useState<any>(null);

    const toggleMenu = (event: React.SyntheticEvent) => {
        setAnchorMenu(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchorMenu(null);
    };

    return (
        <React.Fragment>
            <IconButton
                aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
                aria-haspopup="true"
                onClick={toggleMenu}
                color="inherit"
            >
                <Power/>
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchorMenu}
                open={Boolean(anchorMenu)}
                onClose={closeMenu}
            >
                <MenuItem onClick={closeMenu}>
                    Профиль
                </MenuItem>
                <MenuItem onClick={props.logout}>
                    Выйти
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}


interface OwnProps {
    onDrawerToggle: React.MouseEventHandler<HTMLElement>;
}

const Header: React.FC<OwnProps> = ({ onDrawerToggle }) => {
    const { signOut } = useSession();
    return <React.Fragment>
        <AppBar position="sticky" elevation={0}>
            <Toolbar>
                <Grid container alignItems="center">
                    <Hidden lgUp>
                        <Grid item>
                            <IconButton
                                color="inherit"
                                aria-label="Open drawer"
                                onClick={onDrawerToggle}
                            >
                                <MenuIcon/>
                            </IconButton>
                        </Grid>
                    </Hidden>
                    <Grid item>
                        <div style={{ color: "#000", marginLeft: 10, display: "flex" }}>
                            <Typography variant="h4" display="block" id={PAGE_TITLE_SLOT_ID}/>
                        </div>
                    </Grid>
                    <Grid item xs/>
                    <Grid item>
                        <span id={PAGE_HEADER_ACTIONS_SLOT_ID}/>
                        <div style={{ minWidth: 20, display: "inline-block" }}/>
                        {/*<IconButton color="inherit">
              <Indicator badgeContent={3}>
                <MessageSquare />
              </Indicator>
            </IconButton>*/}

                       {/* <IconButton color="inherit">
                            <Indicator badgeContent={7}>
                                <Bell/>
                            </Indicator>
                        </IconButton>*/}
                        {/*<LanguageMenu />*/}
                        <UserMenu logout={signOut}/>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    </React.Fragment>
};

export default Header;
